export const SIDEBAR_WIDTH = 272;
export const ToggleGlobalFilterSearchStatusEvent =
  "ToggleGlobalFilterSearchStatusEvent";
